import ioannUstenko from '../assets/images/pastors/ioann-ustenko.webp';
import dennisKanchurin from '../assets/images/pastors/dennis-kanchurin.webp';
import andreyVodolazhsky from '../assets/images/pastors/andrey-vodolazhsky.webp';
import arturBagdasaryan from '../assets/images/pastors/artur-bagdasaryan.webp';
import nazarUstenko from '../assets/images/pastors/nazar-ustenko.png';

export const pastorsData = [
    {
        id: 1,
        nameKey: 'pastor_ioann_name',
        roleKey: 'pastor_ioann_role',
        photo: ioannUstenko,
        social: {
            facebook: 'https://www.facebook.com/ioann.ustenko',
            youtube: 'https://www.youtube.com/watch?v=zuXCQSGfoRw&list=PLQR60Ona_FQx0x-2j89-y-3TtRY2E4n3G&index=4'
        }
    },
    {
        id: 2,
        nameKey: 'pastor_dennis_name',
        roleKey: 'pastor_dennis_role',
        photo: dennisKanchurin,
        social: {
            facebook: 'https://www.facebook.com/denniskanchurin',
            youtube: 'https://youtu.be/plGPi6Tm8LU?list=PLQR60Ona_FQx0x-2j89-y-3TtRY2E4n3G&t=13'
        }
    },
    {
        id: 3,
        nameKey: 'pastor_andrey_name',
        roleKey: 'pastor_andrey_role',
        photo: andreyVodolazhsky,
        social: {
            facebook: 'https://www.facebook.com/avodolazhsky',
            youtube: 'https://www.youtube.com/watch?v=cMJ8zCBQf-8&list=PLQR60Ona_FQx0x-2j89-y-3TtRY2E4n3G&index=5'
        }
    },
    {
        id: 4,
        nameKey: 'pastor_artur_name',
        roleKey: 'pastor_artur_role',
        photo: arturBagdasaryan,
        social: {
            facebook: 'https://www.facebook.com/artur.bagdasaryan',
            youtube: 'https://www.youtube.com/@arturbagdasaryan'
        }
    },
    {
        id: 5,
        nameKey: 'pastor_nazar_name',
        roleKey: 'pastor_nazar_role',
        photo: nazarUstenko,
        social: {
            facebook: 'https://www.facebook.com/nazar.ustenko',
            youtube: 'https://www.youtube.com/@nazarustenko'
        }
    }
];
